import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { ISelectValue } from 'constants/globalTypes'
import { Box, Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'


export const AddPermit = () => {
    const handleSelect = (value: ISelectValue) => null
    const handleDate = () => null

    return <>
        <NavBar />
        <PageWrapper>
            <Flex>
                <H1WithBack arrow title='Add Permit' />
            </Flex>
            <Flex mt='32' gap='1rem'>
                <Flex gap='1rem' column width='100%' >
                    <Container>
                        <ContainerHeader><TitleText weight='bold' >Identity</TitleText></ContainerHeader>
                        <ContainerContent>
                            <HonestSelectInput options={[]} name='type' labelText='Permit Type' onChange={handleSelect} />
                        </ContainerContent>
                    </Container>
                    <Container>
                        <ContainerHeader><TitleText weight='bold' >Validity</TitleText></ContainerHeader>
                        <ContainerContent>
                            <Flex gap='1rem' >
                                <CalendarInput labelText='Valid From' />
                                <CalendarInput labelText='Valid Until' />
                            </Flex>
                        </ContainerContent>
                    </Container>
                    <Container>
                        <ContainerHeader><TitleText weight='bold' >Scope</TitleText></ContainerHeader>
                        <ContainerContent>
                            <HonestSelectInput options={scopeOptions} name='scope' labelText='Zone Scope Level' onChange={handleSelect} />
                        </ContainerContent>
                    </Container>
                </Flex>
                <Container>
                    <ContainerHeader><TitleText weight='bold' >Holders and conditions</TitleText></ContainerHeader>
                    <ContainerContent>
                        <Flex gap='1rem' >
                            <Box width='100%' >
                                <TitleText>Holders</TitleText>
                                <Flex mt='16' gap='1rem' alignEnd >
                                    <HonestSelectAsyncInput
                                        nomarg
                                        link='users/basic'
                                        name='employee'
                                        labelText='Employee'
                                        onChange={() => null}
                                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, profilePictureUrl: i.getImagePresignedUrl, value: i.id, id: i.accessCardId, role: i.role, gender: i.gender, tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy }))}
                                    />
                                    <Button orange >Add</Button>
                                </Flex>
                                <Flex mt='16' column gap='0.5rem'>
                                    <Flex width='100%' between >
                                        <TitleText>Michael Jackson</TitleText>
                                        <CloseIcon />
                                    </Flex>
                                    <Flex width='100%' between >
                                        <TitleText>Michael Jackson</TitleText>
                                        <CloseIcon />
                                    </Flex>
                                    <Flex width='100%' between >
                                        <TitleText>Michael Jackson</TitleText>
                                        <CloseIcon />
                                    </Flex>

                                </Flex>
                            </Box>
                            <Input height='12rem' width='100%' type='textarea' labelText='Conditions (optional)' />
                        </Flex>
                    </ContainerContent>
                </Container>
            </Flex>


            <PageFooter>
                <Flex gap='1rem' mt='32' justend >
                    <Button>Cancel</Button>
                    <Button orange>Create</Button>
                    <Button orangeBorder >Create and Issue</Button>
                </Flex>
            </PageFooter>
        </PageWrapper>
    </>
}

const scopeOptions = [
    { label: 'Zone', value: 'zone' },
    { label: 'Section', value: 'zone' },
    { label: 'Blok', value: 'location' },
    { label: 'Pit', value: 'site' },
]